import { useMemo } from 'react'

import { formatEther } from 'viem'
import { useReadContract } from 'wagmi'
import { getChainId } from 'wagmi/actions'

import { useCoinGeckoPrices } from './useCoinGeckoPrices'

import { config } from '@/config/wagmi'
import { useValueTokens } from '@/contexts/VaultTokensContext'
import seaAVAX from '@/contracts/seaAVAX'
import xGGP from '@/contracts/xGGP'

// Combined USD TVL across both vaults: seaAVAX totalAssets (AVAX) priced in USD
// plus xGGP totalAssets (GGP) priced in USD. Returns null until data is ready.
export function useTotalTvl() {
  const { tokens } = useValueTokens()
  const chainId = getChainId(config)
  const { prices } = useCoinGeckoPrices()

  const avaxAddr = tokens.find((t) => t.value === 'avax')?.tokenAddresses[1][chainId]
  const ggpAddr = tokens.find((t) => t.value === 'ggp')?.tokenAddresses[1][chainId]

  const { data: avaxAssets } = useReadContract({
    query: { refetchInterval: 30000 },
    address: avaxAddr as `0x${string}`,
    abi: seaAVAX,
    functionName: 'totalAssets',
  })

  const { data: ggpAssets } = useReadContract({
    query: { refetchInterval: 30000 },
    address: ggpAddr as `0x${string}`,
    abi: xGGP,
    functionName: 'totalAssets',
  })

  const tvlUsd = useMemo(() => {
    if (!prices) return null
    const avaxUsd = prices['avalanche-2']?.usd ?? 0
    const ggpUsd = prices['gogopool']?.usd ?? 0
    const avaxValue = avaxAssets ? Number(formatEther(avaxAssets as bigint)) * avaxUsd : 0
    const ggpValue = ggpAssets ? Number(formatEther(ggpAssets as bigint)) * ggpUsd : 0
    return avaxValue + ggpValue
  }, [avaxAssets, ggpAssets, prices])

  return { tvlUsd }
}
